<iframe
  #frame
  class="pc-layout-thumb__frame"
  [class.pc-layout-thumb__frame--pending]="showOverlay"
  title=""
  tabindex="-1"
  (load)="onFrameLoad()"
></iframe>
@if (showOverlay) {
  <div class="pc-layout-thumb__overlay" aria-busy="true">
    <mat-spinner diameter="20"></mat-spinner>
  </div>
}
